import React from 'react';
import { VictoryAxis, VictoryLabel } from 'victory';

import { isOddHour, ticksEveryOtherHourIncludingLast, generateTickValues } from './Timeline.helpers';

export const timelineChartAxisX = ({ timeAxisHeight, orientation, chartDay, ...props }) => (
    <VictoryAxis
        orientation={orientation}
        name={`time-axis-${orientation}`}
        key={`time-axis-${orientation}`}
        scale="time"
        tickLabelComponent={
            <VictoryLabel textAnchor="start" dy={orientation === 'bottom' ? -timeAxisHeight : timeAxisHeight} dx={5} />
        }
        style={{
            axis: { strokeWidth: 0 },
            ticks: {
                size: (datum) => (isOddHour(datum.tickValue) ? 0 : timeAxisHeight),
            },
        }}
        tickCount={24}
        dependentAxis
        tickValues={generateTickValues(chartDay)}
        tickFormat={ticksEveryOtherHourIncludingLast()}
        {...props}
    />
);
